import React, { useEffect, useRef, useState } from "react";
import { Breadcrumbs } from "../../AbstractElements";
// import FilterListing from "../../Common/FilterListing";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import lists, { tableColumns } from "../../Data/Listing/lists";
import { ServerPath } from "../../Constant";
// import { Calendar } from 'react-feather'
// import Calender from "../../Common/Calender";
import SearchIcon from "../../assets/images/svg/search_iconSos.svg";
import { Button, Form } from "react-bootstrap";
import { DateRange } from "react-date-range";
// import axios from "axios";
import { formatISO } from "date-fns";
import { _axios } from "../../utils/axios";

const Listings = () => {
  const [listing, setListing] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const searchRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("all");
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(), // Change from new Date()
      endDate: new Date(), // Change from new Date()
      key: "selection",
    },
  ]);

  const clearDateFilter = () => {
    setDateRange([
      {
        startDate: null, // Change from new Date()
        endDate: null, // Change from new Date()
        key: "selection",
      },
    ]);
    setShowCalendar(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let url = `${ServerPath}/volunteer-essentials`;
        const response = await _axios.post(url);
        const actualData = response?.data?.data;

        const userData = actualData.map((user) => ({
          listing_id: user.listing_id,
          ...user,
          created_on: formatDate(user.created_on),
          modified_on: formatDate(user.modified_on),
          check_in_time: formatAMPM(user.check_in_time),
          check_out_time: formatAMPM(user.check_out_time),
        }));
        setListing(userData);
        console.log("fetchData", actualData);
        // Filter data based on status
      } catch (error) {
        console.error("Error fetching List:", error);
      }
    };
    fetchData();
  }, []);

  console.log("listing", listing);

  const formatDate = (dateString) => {
    try {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Invalid Date";
    }
  };

  const formatAMPM = (data) => {
    const date = new Date(data);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = String(minutes).padStart(2, "0"); // Add leading zero
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  const handleDateRangeChange = (item) => {
    const date = item.selection;
      setDateRange([date]);
    };

    const handleDateSearch = async () => {
      const start = formatISO(dateRange[0].startDate);
      const end = formatISO(dateRange[0].endDate);
      console.log("handleDateSearch", start, end);

    try {
      let url = `${ServerPath}/volunteer-essentials`;
      const response = await _axios.post(url, {
        dateRange: {
          startDate: start,
          endDate: end,
          key: "selection",
        }
      });
      const actualData = response?.data?.data;
      const userData = actualData.map((user) => ({
        ...user,
        created_on: formatDate(user.created_on),
        modified_on: formatDate(user.modified_on),
        check_in_time: formatAMPM(user.check_in_time),
        check_out_time: formatAMPM(user.check_out_time),
      }));
      setListing(userData);
      setShowCalendar(false);
      setDateRange([
        {
          startDate: null, // Change from new Date()
          endDate: null, // Change from new Date()
          key: "selection",
        },
      ]);
      console.log("handleDateSearch", response);
      // setSearchValue("");
      // Filter data based on status
    } catch (error) {
      console.error("Error fetching List:", error);
    }
    }

  const handleSearch = async (value) => {
    setSearchValue(value);
    try {
      let url = `${ServerPath}/volunteer-essentials`;
      const response = await _axios.post(url, {
        searchText: value,
      });
      const actualData = response?.data?.data;
      const userData = actualData.map((user) => ({
        ...user,
        created_on: formatDate(user.created_on),
        modified_on: formatDate(user.modified_on),
        check_in_time: formatAMPM(user.check_in_time),
        check_out_time: formatAMPM(user.check_out_time),
      }));
      setListing(userData);
      // setShowSearch(false);
      // setSearchValue("");
      // Filter data based on status
    } catch (error) {
      console.error("Error fetching List:", error);
    }
  };

  const handleFilterChange = async (status) => {
    console.log("status", status);
    let value = "";
    if (status === "all") {
      value = "";
    } else if (status === "pending") {
      value = 0;
    } else if (status === "active") {
      value = 1;
    } else if (status === "deactivated") {
      value = 2;
    }
    console.log("value", value);
    try {
      let url = `${ServerPath}/volunteer-essentials`;
      const response = await _axios.post(url, {
        status: value,
      });
      const actualData = response?.data?.data;
      console.log("handleFilterChange", actualData);
      const userData = actualData.map((user) => ({
        ...user,
        created_on: formatDate(user.created_on),
        modified_on: formatDate(user.modified_on),
        check_in_time: formatAMPM(user.check_in_time),
        check_out_time: formatAMPM(user.check_out_time),
      }));
      setListing(userData);
      setShowDropdown(false);

      // Filter data based on status
    } catch (error) {
      console.error("Error fetching List:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-6">
          <Breadcrumbs mainTitle="Listings" parent="Tables" title="User List" />
        </div>
        <div className="col-12 col-md-6 col-lg-6">
          <div className="d-flex justify-content-end align-items-center">
            <div>
              <div className="relative search-dropdown" ref={searchRef}>
                <button
                  className="btn-square btn btn-primary mx-2"
                  onClick={() => setShowSearch(!showSearch)}
                >
                  <i className="icon-search"></i>
                </button>

                {showSearch && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      left: "250px",
                      width: "220px",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        background: "white",
                        borderRadius: "8px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "center",
                          background: "#F8F7FA",
                          borderRadius: "6px",
                          padding: "6px 12px",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search Here..."
                          value={searchValue}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{
                            width: "100%",
                            border: "none",
                            background: "transparent",
                            fontSize: "14px",
                            color: "#666",
                            outline: "none",
                          }}
                          autoFocus
                        />
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => handleSearch(searchValue)}
                        >
                          <img
                            src={SearchIcon}
                            alt="search"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="relative calendar-dropdown" ref={calendarRef}>
              <button
                className="btn-square btn btn-primary mx-2"
                onClick={() => setShowCalendar(!showCalendar)}
              >
                <i className="icon-calendar"></i>
              </button>

              {showCalendar && (
                <div
                  className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                  style={{
                    width: "auto",
                    maxWidth: "300px",
                    zIndex: 1000,
                    right: 0,
                  }}
                >
                  <style>
                    {`
                      .date-range {
                       font-size: 12px !important;
                                            }
                                            .date-range .rdrMonth {
                                                width: 240px !important;
                                                padding: 0 !important;
                                            }
                                            .date-range .rdrCalendarWrapper {
                                                font-size: 12px !important;
                                                width: 240px !important;
                                                border-radius: 8px !important;
                                                overflow: hidden !important;  /* This will ensure content doesn't overflow */
                                                background: white !important;
                                            }
                                            .date-range .rdrDateDisplayWrapper {
                                                display: none !important;
                                            }
                                            .rdrMonthAndYearWrapper {
                                                padding-top: 5px !important;
                                                height: 40px !important;
                                            }
                                            .rdrMonth {
                                                padding: 0 !important;
                                            }
                                        `}
                  </style>
                  <DateRange
                    editableDateInputs={true}
                    onChange={handleDateRangeChange}
                    moveRangeOnFirstSelection={true}
                    ranges={dateRange}
                    maxDate={new Date()}
                    months={1}
                    direction="horizontal"
                    className="date-range"
                    staticRanges={[]}
                    inputRanges={[]}
                    rangeColors={["#0066ff"]}
                    minDate={new Date("2000-01-01")}
                    showSelectionPreview={true}
                    showMonthAndYearPickers={true}
                    monthDisplayFormat="MMMM yyyy"
                    dayDisplayFormat="d"
                    showDateDisplay={true}
                    monthsShown={1}
                  />
                  <div className="d-flex justify-content-end mt-2 gap-2">
                  <Button
                      
                      variant="outline-primary"
                      size="sm"
                      onClick={handleDateSearch}
                    >
                      Done
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={clearDateFilter}
                    >
                      Clear
                    </Button>
                  </div>
                </div>
              )}
            </div>

            {/* <Calender /> */}

            <div className="relative filter-dropdown" ref={dropdownRef}>
              <button
                className="btn-square btn btn-primary mx-2"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <i className="icon-filter"></i>
              </button>

              {showDropdown && (
                <div
                  className="position-absolute bg-white rounded shadow-sm border"
                  style={{
                    right: 0,
                    top: "95%",
                    marginTop: "-10px",
                    marginLeft: "0px",
                    marginRight: "20px",
                    zIndex: 1000,
                    minWidth: "150px",
                    padding: "10px",
                  }}
                >
                  <Form>
                    <Form.Check
                      type="checkbox"
                      id="filter-all"
                      label="All"
                      value={"all"}
                      checked={status === "all"}
                      onChange={(e) => {
                        handleFilterChange(e.target.value);
                        setStatus(e.target.value);
                      }}
                    />
                    <Form.Check
                      type="checkbox"
                      id="filter-pending"
                      label="Pending"
                      value={"pending"}
                      checked={status === "pending"}
                      onChange={(e) => {
                        handleFilterChange(e.target.value);
                        setStatus(e.target.value);
                      }}
                    />
                    <Form.Check
                      type="checkbox"
                      id="filter-active"
                      label="Active"
                      value={"active"}
                      checked={status === "active"}
                      onChange={(e) => {
                        handleFilterChange(e.target.value);
                        setStatus(e.target.value);
                      }}
                    />
                    <Form.Check
                      type="checkbox"
                      id="filter-deactivated"
                      label="Deactivated"
                      value={"deactivated"}
                      checked={status === "deactivated"}
                      onChange={(e) => {
                        handleFilterChange(e.target.value);
                        setStatus(e.target.value);
                      }}
                    />
                  </Form>
                </div>
              )}
            </div>

            {/* <FilterListing /> */}
          </div>
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12" className="align-items-center">
            <Card>
              <CardBody className="pt-0">
                <DataTable
                  className="data-tables theme-scrollbar pt-4"
                  data={listing}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  //   onSelectedRowsChange={handleRowSelected}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Listings;
